import React from "react";
import Preloader from "../helper/Preloader";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
import HeaderOneCustomer from "../componentsAmazon/HeaderOneCustomer";
import ProductDetailsReturnedOneAmazon from "../componentsAmazon/ProductDetailsReturnedOneAmazon";
 import {   setSelectedProduct } from '../common/slices/productSlice';
import { useDispatch } from "react-redux";

const WholesaleCenterProductsDetails = () => {

  const dispatch = useDispatch();
 // const selectedProduct = useSelector((state) => state.product.selectedProduct);

  const handleBackToWholesale = () => {
    dispatch(setSelectedProduct(null)); // Clear selected product
  };
 
  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#232F3F" />


      {/* HeaderOneCustomer */}
      <HeaderOneCustomer />

      {/* Conditionally Render ProductDetailsReturnedOneAmazon */}
      
    <ProductDetailsReturnedOneAmazon/>
      
      {/* FooterOne */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default WholesaleCenterProductsDetails;
